import * as actionTypes from "../actions/actionTypes";

const initialState = {
    url: null,
    show: false,
};

const showShareUrl = (state, action) => {
    return {
        ...state,
        url: action.url,
        show: true,
    };
};

const hideShareUrl = (state, action) => {
    return {
        ...state,
        url: null,
        show: false,
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SHOW_SHARE_URL:
            return showShareUrl(state, action);
        case actionTypes.HIDE_SHARE_URL:
            return hideShareUrl(state, action);
        default:
            return state;
    }
};

export default reducer;
